"use client";

import Link from "next/link";
import { FadeUp, StaggerGroup, StaggerItem, TextReveal } from "@/components/marketing/animations";

const FEATURES = [
  "Photos pro g\u00e9n\u00e9r\u00e9es automatiquement",
  "Titre et description optimis\u00e9s",
  "Hashtags et prix sugg\u00e9r\u00e9",
  "Export multi-plateforme",
  "Historique illimit\u00e9",
];

export default function PricingSection() {
  return (
    <section
      id="pricing"
      style={{
        padding: "120px 5vw",
        textAlign: "center",
        borderRadius: '32px 32px 0 0',
        marginTop: -32,
        position: 'relative',
        zIndex: 3,
        background: '#FDF6EE',
      }}
    >
      <FadeUp>
        <p
          style={{
            fontSize: 16,
            color: "rgba(44,37,32,0.5)",
            marginBottom: 12,
          }}
        >
          {"Pas de tableau \u00e0 3 colonnes."}
        </p>
      </FadeUp>
      <h2
        style={{
          fontFamily: "var(--font-newsreader), Georgia, serif",
          fontStyle: "italic",
          fontSize: "clamp(36px, 5vw, 56px)",
          marginBottom: 48,
        }}
      >
        <TextReveal text="Un prix. Simple." stagger={0.08} />
      </h2>

      <FadeUp delay={0.2}>
        <div
          style={{
            maxWidth: 440,
            margin: "0 auto",
            background: "#fff",
            borderRadius: 24,
            padding: "48px 36px",
            boxShadow: "0 20px 60px rgba(44,37,32,0.10)",
            border: "1px solid rgba(232,221,209,0.5)",
          }}
        >
          {/* Beta badge */}
          <span
            style={{
              display: "inline-block",
              fontSize: 12,
              fontWeight: 700,
              letterSpacing: 2,
              textTransform: "uppercase",
              color: "var(--color-mkt-terracotta)",
              border: "1.5px solid var(--color-mkt-terracotta)",
              padding: "4px 16px",
              borderRadius: 99,
              marginBottom: 24,
            }}
          >
            Beta
          </span>

          {/* Price */}
          <div
            style={{
              fontFamily: "var(--font-newsreader), Georgia, serif",
              fontSize: 72,
              fontWeight: 700,
              lineHeight: 1,
              marginBottom: 4,
              letterSpacing: -2,
            }}
          >
            0 EUR
          </div>
          <div
            style={{
              fontSize: 20,
              color: "rgba(44,37,32,0.4)",
              textDecoration: "line-through",
              marginBottom: 32,
            }}
          >
            9,99 EUR / mois
          </div>

          {/* Feature list */}
          <StaggerGroup
            stagger={0.06}
          >
            {FEATURES.map((feature, idx) => (
              <StaggerItem key={feature}>
                <div
                  role="listitem"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 12,
                    padding: "10px 0",
                    borderBottom:
                      idx < FEATURES.length - 1
                        ? "1px solid rgba(232,221,209,0.5)"
                        : "none",
                    fontSize: 15,
                  }}
                >
                  <span
                    className="material-symbols-outlined"
                    aria-hidden="true"
                    style={{
                      color: "var(--color-mkt-forest)",
                      fontSize: 20,
                    }}
                  >
                    check_circle
                  </span>
                  {feature}
                </div>
              </StaggerItem>
            ))}
          </StaggerGroup>

          {/* CTA */}
          <Link
            href="/login"
            className="mkt-cta-btn"
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: 8,
              background: "var(--color-mkt-chocolate)",
              color: "var(--color-mkt-cream)",
              padding: "16px 36px",
              borderRadius: 99,
              fontSize: 16,
              fontWeight: 600,
              textDecoration: "none",
              border: "none",
              cursor: "pointer",
              width: "100%",
              justifyContent: "center",
            }}
          >
            Rejoindre la beta
          </Link>
        </div>
      </FadeUp>

      {/* Mobile responsive override */}
      <style>{`
        @media (max-width: 768px) {
          .btn-primary-pricing {
            margin: 0 8px;
          }
        }
      `}</style>
    </section>
  );
}
